
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"comp-dots-horizontal","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('g',{attrs:{"transform":"translate(-379.095 -239.605)"}},[_c('circle',{staticClass:"cls-2",attrs:{"cx":"1.3","cy":"1.3","r":"1.3","transform":"translate(395.866 250.605)"}}),_c('circle',{staticClass:"cls-2",attrs:{"id":"Ellipse_2042","cx":"1.3","cy":"1.3","r":"1.3","transform":"translate(389.981 250.605)"}}),_c('circle',{staticClass:"cls-2",attrs:{"id":"Ellipse_2043","cx":"1.3","cy":"1.3","r":"1.3","transform":"translate(384.095 250.605)"}})])])
          )
        }
      }
    